module.exports = __webpack_public_path__ + "static/media/vocepodemais.6b3a0157.png";